import firebase from "../../firebase";
const db = firebase.firestore();

const getPartnerAccounts = async (userId) => {
  try {
    let partnerPermissionsSnap = await db
      .collection("users")
      .doc(userId)
      .collection("partnerAccounts")
      .get();
    let accountIds = [];

    partnerPermissionsSnap.forEach((permissionSnap) => {
      let permission = permissionSnap.data();
      accountIds.push(permission.accountId);
    });

    if (!accountIds.length) return;
    let accounts = [];
    let fetchPromises = accountIds.map((x) =>
      db
        .collection("partnerAccounts")
        .doc(x)
        .get()
    );
    let accountSnaps = await Promise.all(fetchPromises);
    for (let accountSnap of accountSnaps) {
      if (accountSnap.exists) {
        accounts.push(accountSnap.data());
      }
    }
    return accounts;
  } catch (e) {
    console.error(e);
    throw new Error("An error occurred while fetching partner accounts");
  }
};

export default {
  getPartnerAccounts,
};
